module.exports = __webpack_public_path__ + "img/pink_key-lg.4b06e7bd.jpg";